import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DataStorageService } from "../../../services/data-storage.service";
import { Router } from "@angular/router";
import { PetInsuranceData } from "../../../models";

@Component({
  selector: 'cpf-desktop-home',
  templateUrl: './desktop-home.component.html',
  styleUrls: ['./desktop-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DesktopHomeComponent {
  topComponentCollapsed = false;
  pets: PetInsuranceData[] = [];

  constructor(
    public dataStorageService: DataStorageService,
    private router: Router
  ) {
    this.dataStorageService.loaded$.subscribe((loaded) => {
      if (loaded) {
        this.pets = this.dataStorageService.getAllData;
      }
    });
  }

  onCardSelectionChange(index: number) {
    this.dataStorageService.selectedData = this.dataStorageService.getAllData[index];
  }

  navigateInvoiceDetails(id: string) {
    this.router.navigate(['desktop', 'home', 'pet', 'invoice', id]);
  }

  navigateClaimDetails(id: string) {
    this.router.navigate(['desktop', 'home', 'pet', 'claims', id]);
  }

  navigateInsuranceDetails() {
    this.router.navigate(['desktop', 'home', 'pet', 'insurance', 'details']);
  }

  navigateEditPetInfo() {
    this.router.navigate(['desktop', 'home', 'pet', 'insurance', 'edit-pet-info']);
  }

  navigateEditInsuranceInfo() {
    this.router.navigate(['desktop', 'home', 'pet', 'insurance', 'edit-insurance-info']);
  }

  navigatePetFnol() {
    this.router.navigate(['desktop', 'home', 'fnol']);
  }

  navigateFnolDetails(id: string) {
    this.router.navigate(['desktop', 'home', 'pet', 'fnol-details', id]);
  }

  toggleTopComponentCollapsed() {
    this.topComponentCollapsed = !this.topComponentCollapsed;
  }
}
